function downloadFileFromHref(fileName, href, dataTaktId) {
  const win = document.defaultView || window;
  if (!win) {
    return;
  }
  const element = document.createElement('a');
  element.setAttribute('href', href);
  element.setAttribute('download', fileName);
  element.setAttribute('data-takt-id', dataTaktId);
  element.style.display = 'none';
  document.body.appendChild(element);
  element.dispatchEvent(new MouseEvent('click', {
    bubbles: false,
    cancelable: true,
    view: win
  }));
  document.body.removeChild(element);
}

export { downloadFileFromHref as d };
//# sourceMappingURL=downloadFileFromHref-kavfT3WV.js.map
